const ProfileEmployee = () => import('../views/ProfileEmployee.vue')
const ReadFile = () => import('../views/readFile.vue')
export default [
  {
    path: '/entity/profile',
    component: ProfileEmployee,
    meta: { requiresAuth: true },
    name: 'Profile',
    props: true
  },
  {
    path: '/entity/profile/document/:file',
    component: ReadFile,
    meta: { requiresAuth: true },
    name: 'Profile',
    props: true
  }
]
